import { DotsIcon, UploadIcon } from "components/layout/icons/Icons";
import { isNullOrEmpty } from "components/helpers/ObjectHelpers";
import { IconColors, WorkTimeActivityType, WorkTimePeriodType } from "services/SystemNames";

function isWorkTimeRest(workTime) {
    return workTime.workTimePeriodType.value === WorkTimePeriodType.RestingTime;
}

function activityHasPilotage(activity) {
    if (isNullOrEmpty(activity)) return false;
    return activity === WorkTimeActivityType.Piloting
        || activity === WorkTimeActivityType.OnboardExaminer
        || activity === WorkTimeActivityType.OnboardTrainee
        || activity === WorkTimeActivityType.PilotingMultiplePilotsPilotage
}
function activityIsMidJourneyRest(activity) {
    if (isNullOrEmpty(activity)) return false;
    return activity === WorkTimeActivityType.MidJourneyStop;
}

function activityIsMultiplePilotage(activity) {
    if (isNullOrEmpty(activity)) return false;
    return activity === WorkTimeActivityType.PilotingMultiplePilotsPilotage
        || activity === WorkTimeActivityType.RestingMultiplePilotsPilotage
}

function activityisPiloting(activity) {
    if (isNullOrEmpty(activity)) return false;
    return activity === WorkTimeActivityType.Piloting
        || activity === WorkTimeActivityType.OnboardExaminer
        || activity === WorkTimeActivityType.OnboardTrainee
        || activity === WorkTimeActivityType.PilotingMultiplePilotsPilotage
}

function activityIsRegularPiloting(activity) {
    if (isNullOrEmpty(activity)) return false;
    return activity === WorkTimeActivityType.Piloting
        || activity === WorkTimeActivityType.OnboardExaminer
        || activity === WorkTimeActivityType.OnboardTrainee
}

function activityHasAppointment(activity) {
    if(isNullOrEmpty(activity)) return false;
    return activity === WorkTimeActivityType.Meeting
        || activity === WorkTimeActivityType.Course;
}

function activityIsRest(activity) {
    if (isNullOrEmpty(activity)) return false;
    return activity === WorkTimeActivityType.Rest
}

function getActivitySuggestionIcon(activitySuggestion) {
    if (!activitySuggestion.canBeAutoStamped) {
        return DotsIcon;
    }

    if(activityIsMultiplePilotage(activitySuggestion.activityType.systemName)) {
        return DotsIcon;
    }

    if (activityIsRegularPiloting(activitySuggestion.activityType.systemName)) {
        if (activitySuggestion.pilotages.length === 0) {
            return DotsIcon;
        } else if (activitySuggestion.pilotages.length > 1) {
            return DotsIcon;
        }
    }
    return UploadIcon;
}

function getSubTextFloatingActionButton(activitySuggestion) {
    if (activityIsRegularPiloting(activitySuggestion.activityType.systemName) && activitySuggestion.pilotages.length === 1) {
        return activitySuggestion.pilotages[0].shipName;
    }
    return "";
}

function getBorderColor(workTime) {
    if(isNullOrEmpty(workTime)) return "var(--card-border)";
    if (workTime.activityType.systemName === 'NONE' && workTime.workTimePeriodType.value === WorkTimePeriodType.WorkingTime) {
        return "var(--pto-status-ordered-boarder)";
    }
    else if (workTime.isOnRequiredRest || isWorkTimeRest(workTime)) {
        return "var(--pto-status-confirmed-boarder)";
    }
    else if (activityisPiloting(workTime.activityType.systemName)) {
        return "var(--pto-status-ordered-boarder)";
    }
    else {
        return "var(--card-border)";
    }
}

function getIconColor(workTime) {
    if(isNullOrEmpty(workTime)) return IconColors.Primary;;

    if(isWorkTimeRest(workTime)) {
        return IconColors.AssignmentConfirmed;
    }
    if (workTime.activityType.systemName === 'NONE' && workTime.workTimePeriodType.value === WorkTimePeriodType.WorkingTime) {
        return IconColors.AssignmentAssigned;
    }
    if(activityisPiloting(workTime.activityType.systemName)) {
        return IconColors.AssignmentAssigned;
    }
    return IconColors.Primary;
}

export {
    isWorkTimeRest,
    activityHasPilotage,
    activityIsMidJourneyRest,
    activityIsMultiplePilotage,
    activityIsRest,
    getBorderColor,
    getIconColor,
    activityHasAppointment,
    getActivitySuggestionIcon,
    getSubTextFloatingActionButton,
    activityIsRegularPiloting,
    activityisPiloting
}
